import React, {Component} from 'react';

/** @class RoleOptions
  * Provides a list of roles as an optgroup of options.
  * This can be used in all role drop-down menus and
  * provides a single point in the code to add roles.
  */
export default class RoleOptions extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <optgroup label="Vexpo Roles">
        <option value="Admin">Admin</option>
        <option value="Affiliate Manager">Affiliate Manager</option>
        <option value="Expo Editor">Expo Editor</option>
        <option value="Booth Builder">Booth Builder</option>
        <option value="Unassigned">Unassigned</option>
      </optgroup>
    )
  }
}

RoleOptions.propTypes = {}



// WEBPACK FOOTER //
// ./src/user-list/role-options.js